import { appCountryBlockedRouteI18n } from '../i18n/app-country-blocked-route-i18n';
import { langRouteI18n } from '../i18n/lang-route-i18n';

export function appCountryBlockedRoutePath(): string {
  return `/${langRouteI18n()}/${appCountryBlockedRouteI18n()}`;
}
